/* MODULE IMPORTS */
import React, { Component } from "react";
import mymontepioappImg from "../../images/mymontepioapp.png";

import "./MyMontepioAppPopup.css";

class MyMontepioapp extends Component {
    static displayName = MyMontepioapp.name;

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className="popup-campanha">
                <div className="popup-content">

                    <button
                        className="popup-close"
                        onClick={() => {
                            this.props.close();
                        }}
                    >
                        X
                    </button>


                    <div className="popup-campanha-text">
                        <img
                            src={mymontepioappImg}
                            alt="mymontepio popup"
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default MyMontepioapp;
